import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useLocalisation } from '@3plearning/lingui-cdn';
import moment from 'moment';

import Checkbox from '@components/checkbox';
import { CHECKED, UNCHECKED } from '@components/checkbox/constants';

import { toggleAssignmentIds } from '../../redux/actions';

import { Root, Text, CheckboxWrapper, EllipsisText, DueDate } from './styled';


const Assignment = (props) => {

  const {
    assignment: {
      accuracy,
      assigned,
      assignmentId,
      courseName,
      learningJourneyName,
      stepsCompleted,
      stepsCount,
	  dueDate,
	  currentAssignmentUnavailableForStudent
    }
  } = props;

  const dispatch = useDispatch();
  const selectedAssignmentIds = useSelector(state => state.currentAssignmentsModalReducer.selectedAssignmentIds);

  const { i18n } = useLocalisation();

  const isNotAttempted = stepsCompleted === 0;

  return (
    <Root>
      <CheckboxWrapper>
        <Checkbox
          checkboxHandler={() => dispatch(toggleAssignmentIds(assignmentId))}
          state={selectedAssignmentIds.includes(assignmentId) ? CHECKED : UNCHECKED}
        />
      </CheckboxWrapper>
      <Text width="40%" alignHorizontal="flex-start">
        <EllipsisText>{learningJourneyName}</EllipsisText>
      </Text>
      <Text width="35%" alignHorizontal="flex-start">
        <EllipsisText>{courseName}</EllipsisText>
      </Text>
      <Text>{isNotAttempted ? i18n.t`Not attempted` : `${accuracy} %`}</Text>
      <Text>{isNotAttempted ? i18n.t`Not attempted` : `${stepsCompleted}/${stepsCount}`}</Text>
      <Text>{moment(assigned).format('DD.MM.YYYY')}</Text>
      <DueDate
        currentAssignmentUnavailableForStudent={currentAssignmentUnavailableForStudent}>
        {moment(dueDate).format('DD.MM.YYYY')}
      </DueDate>
    </Root>
  );
};

Assignment.propTypes = {
  assignment: PropTypes.object.isRequired
};

export default Assignment;
